import Swiper from '//www.kewlioo.com/cdn/shop/t/97/assets/swiper-bundle.esm.browser.min.js?v=62541656377908103831705966906';

{
//if (!document.swiper) {
    const blocks = document.querySelectorAll('.product-slider');
    let swiperCss = document.createElement('link');
    const swiperBeforeInit = function (el) {

        el.classList.remove('slides');
        el.classList.add('swiper');
        el.style.position = 'relative';
        el.innerHTML = '<div class="swiper-wrapper">' + el.innerHTML + '</div>';
        el.querySelectorAll('.product-card').forEach((e) => e.classList.add('swiper-slide'));

        el.insertAdjacentHTML('beforeend', '<div class="slider-buttons"><button type="button" data-role="none" class="slider-arrow prev" aria-label="Previous" role="button"></button>' +
            '<button type="button" data-role="none" class="slider-arrow next" aria-label="Next" role="button"></button></div><div class="swiper-pagination"></div>');
    }
    let loadcss = new Promise((resolve, reject) => {
        if (!document.swiper) {
            swiperCss.href = "//cdn.shopify.com/s/files/1/2068/9901/t/97/assets/swiper-bundle.css?v=84395560693144233261666083423";
            swiperCss.media = "all";
            swiperCss.rel = "stylesheet";
            swiperCss.type = "text/css";
            swiperCss.onload = function () {
                resolve();
                document.swiper = true;
            };
            document.head.appendChild(swiperCss);
        } else resolve();
    });

    const breakpoint = window.matchMedia('(min-width:750px)');
    blocks.forEach(function (el) {

        if (el.swiper)
            return;
        let productSwiper;

        const breakpointChecker = function () {

            if (breakpoint.matches === false) {
                if (productSwiper !== undefined) productSwiper.destroy(true, true);
                return;

            } else if (breakpoint.matches === true && (productSwiper === undefined || productSwiper == null || productSwiper.destroyed)) {
                return enableSwiper();
            }

        };
        const enableSwiper = function () {

            swiperBeforeInit(el);
            params.navigation = {
                nextEl: el.querySelector('.next'),
                prevEl: el.querySelector('.prev')
            };
            productSwiper = new Swiper(el, params);
        };
        let params = {
            loop: false,
            slidesPerView: el.dataset.mobile,
            freeMode: true,
            spaceBetween: 12,
            breakpoints: {
                550: {
                    slidesPerView: el.dataset.mobile,
                },
                750: {
                    slidesPerView: el.dataset.desktop,
                    loop: true,
                    spaceBetween: 24,
                }
            },
            on: {
                init: function (swiper) {
                    el.querySelectorAll('.slider-arrow').forEach((e) => e.style.top = (el.querySelector('.swiper-slide-active .photo').offsetHeight / 2) + 'px');

                },
                resize: function (swiper) {
                    el.querySelectorAll('.slider-arrow').forEach((e) => e.style.top = (el.querySelector('.swiper-slide-active .photo').offsetHeight / 2) + 'px');
                },
                beforeInit: function (swiper) {
                    el.classList.remove('row');
                },
                destroy: function (swiper) {
                    let wrap = el.querySelector('.swiper-wrapper');
                    if (wrap) {
                        el.classList.remove('swiper');
                        el.classList.add('row');
                        el.classList.add('slides');
                        el.removeAttribute('style');
                        el.innerHTML = wrap.innerHTML;
                        el.querySelectorAll('.product-card').forEach((e) => e.classList.remove('swiper-slide'));
                        let btn;
                        if (btn = el.querySelector('.slider-buttons'))
                            btn.remove();
                    }
                }
            }
        };

        if (el.querySelectorAll('.product-card').length < 6)
            params.breakpoints['750'].loop = false;

        loadcss.then(function () {
            if (!el.hasAttribute('grid-mobile'))
                enableSwiper(el);
            else {
                breakpoint.onchange = breakpointChecker;
                breakpointChecker();
            }
        });
    });
}
//}